import styled from 'styled-components';
import { Layout } from 'antd';

const StyledLayout = styled(Layout)`
  &.ant-layout {
    /* height: 100%; */
    min-height: 100vh;
  }

  .title {
    height: 32px;
    margin: 16px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
    letter-spacing: 0.3em;
    font-weight: 200;
  }
`;

const StyledHeader = styled(Layout.Header)`
  &.ant-layout-header {
    background: #fff;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  .trigger:hover {
    color: #1890ff;
  }

  .logout {
    margin-left: auto;
    margin-right: 24px;
  }
`;

export { StyledLayout, StyledHeader };
